/*
  HALO Hero: primeira dobra da página de produto (seção HALO Hero).
  - Imagens decorativas descem levemente com a rolagem (parallax), cada uma na sua intensidade.
  - "Comprar agora" sem link próprio rola até a seção de compra da página, descontando o cabeçalho.
  - "Ver vídeo" abre o vídeo num <dialog> nativo (foco, Esc e leitor de tela tratados pelo navegador).
*/
(function () {
  'use strict';

  if (!window.customElements || customElements.get('halo-hero')) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class HaloHero extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.raf = 0;

      this.setupMobileKit();
      this.setupParallax();
      this.setupBuy();
      this.setupVideo();
    }

    disconnectedCallback() {
      if (!this.started) return;
      this.started = false;
      if (this.raf) cancelAnimationFrame(this.raf);
      if (this.io) this.io.disconnect();
      if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
      if (this.kitQuery) this.kitQuery.removeEventListener('change', this.placeKit);
      if (this.kitMarker && this.kitMarker.parentNode) {
        this.kitMarker.after(this.kitElement);
        this.kitMarker.remove();
      }
      if (this.dialog && this.dialog.open) this.dialog.close();
    }

    setupMobileKit() {
      var content = this.querySelector('.halo-hero__content--campaign');
      var kit = this.querySelector('.halo-hero__decor--bottom-left');
      if (!content || !kit) return;
      this.kitQuery = window.matchMedia('(max-width: 767px)');
      var marker = document.createComment('halo-kit-original-position');
      kit.before(marker);
      this.kitMarker = marker;
      this.kitElement = kit;
      this.placeKit = () => {
        if (this.kitQuery.matches) content.insertBefore(kit, content.querySelector('.halo-hero__footer'));
        else marker.after(kit);
      };
      this.kitQuery.addEventListener('change', this.placeKit);
      this.placeKit();
    }

    setupParallax() {
      this.decor = Array.prototype.map.call(this.querySelectorAll('[data-hero-decor]'), function (el) {
        return { el: el, speed: (parseFloat(el.dataset.speed) || 0) / 100 };
      }).filter(function (d) {
        return d.speed !== 0;
      });
      if (!this.decor.length || reduce || this.dataset.parallax !== 'true') return;

      var self = this;
      this.onScroll = function () {
        if (!self.raf) self.raf = requestAnimationFrame(self.parallax.bind(self));
      };
      this.io = new IntersectionObserver(function (entries) {
        if (entries[entries.length - 1].isIntersecting) {
          window.addEventListener('scroll', self.onScroll, { passive: true });
          self.onScroll();
        } else {
          window.removeEventListener('scroll', self.onScroll);
        }
      });
      this.io.observe(this);
    }

    parallax() {
      this.raf = 0;
      // Quanto a seção já subiu: as imagens descem uma fração disso e parecem ficar para trás.
      var scrolled = Math.max(0, -this.getBoundingClientRect().top);
      for (var i = 0; i < this.decor.length; i++) {
        this.decor[i].el.style.setProperty('--py', (scrolled * this.decor[i].speed).toFixed(1) + 'px');
      }
    }

    setupBuy() {
      var link = this.querySelector('[data-hero-buy]');
      if (!link) return;
      link.addEventListener('click', function (e) {
        var target =
          document.querySelector('[id$="__main_product"]') ||
          document.querySelector('xo-product[xo-product-information]');
        if (!target) return; // sem seção de compra na página: segue o link normal
        e.preventDefault();
        var header = document.querySelector('[data-halo-header-bar]') || document.querySelector('.xo-header__inner');
        var offset = header ? Math.max(0, header.getBoundingClientRect().bottom) + 16 : 16;
        var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      });
    }

    setupVideo() {
      var open = this.querySelector('[data-hero-video-open]');
      var dialog = this.querySelector('[data-hero-dialog]');
      if (!open || !dialog || typeof dialog.showModal !== 'function') {
        if (open) open.hidden = true;
        return;
      }
      this.dialog = dialog;
      var video = dialog.querySelector('video');
      var iframe = dialog.querySelector('iframe[data-src]');
      var close = dialog.querySelector('[data-hero-video-close]');

      if (video) {
        video.controls = false;
        video.addEventListener('ended', function () {
          if (dialog.open) dialog.close();
        });
      }

      open.addEventListener('click', function () {
        dialog.showModal();
        if (video) {
          video.currentTime = 0;
          var playing = video.play();
          if (playing && playing.catch) playing.catch(function () {});
        }
        if (iframe) iframe.src = iframe.dataset.src;
      });

      if (close) {
        close.addEventListener('click', function () {
          dialog.close();
        });
      }

      // Clique fora do vídeo (no fundo escurecido) fecha.
      dialog.addEventListener('click', function (e) {
        if (e.target === dialog) dialog.close();
      });

      dialog.addEventListener('close', function () {
        if (video) video.pause();
        if (iframe) iframe.removeAttribute('src');
      });
    }
  }

  customElements.define('halo-hero', HaloHero);
})();
